import script from "./ExerciseKruskalGraph.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExerciseKruskalGraph.vue?vue&type=script&setup=true&lang=ts"

import "./ExerciseKruskalGraph.vue?vue&type=style&index=0&id=4db51ee8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4db51ee8"]])

export default __exports__